var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPython = function SvgPython(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 43 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#python_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.262 0a28.426 28.426 0 0 0-4.757.406c-4.212.745-4.977 2.302-4.977 5.175v3.794h9.955v1.265H7.792c-2.893 0-5.427 1.739-6.22 5.047-.913 3.792-.954 6.158 0 10.118.709 2.947 2.398 5.047 5.292 5.047h3.422v-4.549c0-3.285 2.843-6.184 6.22-6.184h9.943c2.768 0 4.977-2.279 4.977-5.059V5.582c0-2.698-2.276-4.724-4.977-5.175A31.051 31.051 0 0 0 21.262 0ZM15.88 3.052c1.028 0 1.868.853 1.868 1.903 0 1.045-.84 1.89-1.868 1.89a1.879 1.879 0 0 1-1.868-1.89c0-1.05.836-1.903 1.868-1.903Z",
    fill: "url(#python_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.668 10.64v4.421c0 3.427-2.905 6.312-6.219 6.312h-9.943c-2.724 0-4.978 2.331-4.978 5.059v9.48c0 2.697 2.346 4.284 4.978 5.058 3.151.926 6.173 1.094 9.943 0 2.506-.726 4.978-2.186 4.978-5.059v-3.794h-9.944v-1.265H36.404c2.893 0 3.972-2.018 4.978-5.047 1.04-3.118.995-6.117 0-10.117-.715-2.88-2.08-5.047-4.978-5.047h-3.736Zm-5.592 24.006c1.032 0 1.868.846 1.868 1.892 0 1.049-.836 1.903-1.868 1.903-1.029 0-1.868-.854-1.868-1.903 0-1.046.84-1.892 1.868-1.892Z",
    fill: "url(#python_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.444,
    d: "M21.596 50.002c7.367 0 13.34-1.158 13.34-2.587 0-1.429-5.973-2.587-13.34-2.587-7.368 0-13.341 1.158-13.341 2.587 0 1.429 5.973 2.587 13.34 2.587Z",
    fill: "url(#python_svg__d)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "python_svg__b",
    x1: 0.872,
    y1: 0,
    x2: 23.827,
    y2: 19.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A9FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#306998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "python_svg__c",
    x1: 26.837,
    y1: 36.219,
    x2: 18.601,
    y2: 24.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE873"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "python_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -2.58685 11.3703 0 21.595 47.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8",
    stopOpacity: 0.498
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "python_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.872)",
    d: "M0 0h41.272v50H0z"
  })))));
};
export default SvgPython;